import { useQuery } from "@tanstack/react-query";
import { BarChart3 } from "lucide-react";
import { api } from "@/lib/api";
import { prettyDate } from "@/lib/geo";

const TEMPLATE = { dreams: "My bucketlist", top10: "My top 10", best: "My top 5 ever", year: "Year in review", join: "Part 2 · Make your own" };
const CHANNEL = { whatsapp: "WhatsApp", facebook: "Facebook", messenger: "Messenger", instagram: "Instagram", email: "Email", sms: "SMS", copy: "Copied message", native: "Phone share", other: "Other shares" };

const label = (r) => (r.kind === "story" ? `${TEMPLATE[r.template]}${r.format === "square" ? " · square" : ""}` : r.kind === "contact" ? `Invite to ${r.label}` : CHANNEL[r.kind]);

export const StoryStats = ({ open }) => {
  const { data } = useQuery({ queryKey: ["source-stats"], queryFn: api.sourceStats, enabled: open, refetchOnWindowFocus: true });
  const rows = (data || []).filter((r) => r.kind === "story" || r.opens || r.signups);
  return (
    <div className="rounded-xl border border-white/10 p-3" data-testid="story-stats">
      <p className="eyebrow !text-slate-400 mb-2 flex items-center gap-1.5"><BarChart3 size={12} /> Your stories & links</p>
      {rows.length === 0 && <p className="text-xs text-slate-500" data-testid="story-stats-empty">Share or download a story to start counting who opens it.</p>}
      {rows.length > 0 && (
        <table className="w-full text-xs">
          <thead><tr className="text-slate-500"><th className="text-left font-normal pb-1">Shared</th><th className="font-normal pb-1">Opened</th><th className="font-normal pb-1">Made their own</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.code || "other"} className="border-t border-white/5" data-testid={`story-stat-${r.code || "other"}`}>
                <td className="py-1.5 pr-2 text-slate-200">{label(r)}{r.kind === "story" && <span className="text-slate-500"> · {prettyDate(r.created_at.slice(0, 10), "d MMM")}</span>}</td>
                <td className="text-center font-mono text-sky-300" data-testid={`story-stat-opens-${r.code || "other"}`}>{r.opens}</td>
                <td className="text-center font-mono text-emerald-300" data-testid={`story-stat-signups-${r.code || "other"}`}>{r.signups}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
